/** @format */

export interface Image {
  path: string;
  type: string;
}
